import api from './api';

const commercialService = {
  getSalesInvoices: (token)       => api.get('/commercial/invoices', token),
  createInvoice:    (data, token) => api.post('/commercial/invoices', data, token),
  authorizeInvoice: (id, token)   => api.put(`/commercial/invoices/${id}/authorize`, {}, token),
  getProjects:      (token)       => api.get('/commercial/projects', token),
  createProject:    (data, token) => api.post('/commercial/projects', data, token),
  getPriceLists:    (token)       => api.get('/commercial/price-lists', token),
};

export default commercialService;
